



































































































































































































import { Component, Vue } from 'vue-property-decorator'
import HeaderUserMenu from '@/app/components/Common/Header/HeaderUserMenu.vue'
import Local from '@/app/module/local'
import { routerPath } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    HeaderUserMenu
  }
})
export default class Header extends Vue {
  private activeBtn: boolean = false
  private userName: string|null = ''
  private isAuth: boolean = false
  private isAdmin: boolean = false
  private userTypeName: string = '-'
  private constantValue: any = []

  created () {
    if (Local.getAuthToken()) {
      this.isAuth = true
    }

    if (Local.getUserName()) {
      this.userName = Local.getUserName()
    } else {
      this.userName = '名無し'
    }
    this.jugeUserType()
  }

  private jugeUserType () {
    const userType = parseInt(Local.getUserType()!)
    this.constantValue = JSON.parse(Local.getConstantValue()!)

    if (this.constantValue === null) {
      setTimeout(this.jugeUserType, 200)
      return
    }

    // ユーザー情報の
    const userTypeData = this.constantValue.user_types.filter((data: any) => data.user_type_id === userType)
    if (userTypeData.length === 0) {
      this.userTypeName = '-'
    } else {
      this.userTypeName = userTypeData[0].user_type_name
    }
  }

  private stringCut (data: string) {
    if (data !== '' && data !== undefined) {
      if (data.length > 15) {
        return data.substr(0, 14) + '…'
      } else {
        return data
      }
    }
  }

  private doLogout () {
    CommonClass.doSpLogout()
  }
}
